module.exports = __webpack_public_path__ + "static/logo-tagline-56b7f6d2c94009962413c6b2ca34ceec.svg";